module.exports = __webpack_public_path__ + "img/XML.c894d22c.png";